import {parseDate} from 'client/services/utils/date';

export const getTime = (rawValue, withSeconds = false, timezone) =>
  parseDate(rawValue, {timezone, outputFormat: withSeconds ? 'TIME_SECONDS' : 'TIME'});

export const getDate = (rawValue, timezone) => parseDate(rawValue, {timezone, outputFormat: 'DATE'});

export const getValue = (dateValue, timeValue, timezone) =>
  parseDate(dateValue, {timezone, time: timeValue, timezoneForce: true});
